import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { PrivateRoute, NonAuthedRoute, CommonRoute, ByPassPrivateRoute, CrewOnlyRoute } from "./routes/CustomRoutes";
import Loader from "./components/common/loader/index";
import constant from "./constant";
import lazyRetry from "./utils/lazyRetry";

const Login = lazyRetry(() => import("./pages/auth/login"));
const ResetPin = lazyRetry(() => import("./pages/auth/resetPin"));
const ForgetPin = lazyRetry(() => import("./pages/auth/forget"));
const Logout = lazyRetry(() => import("./components/auth/Logout"));
const SetPin = lazyRetry(() => import("./pages/auth/setPin"));
const SsoCallback = lazyRetry(() => import("./pages/auth/ssoCallback"));
const Dashboard = lazyRetry(() => import("./pages/dashboard"));
const CrewDashboard = lazyRetry(() => import("./pages/dashboard/crew"));
const AdminVesselReports = lazyRetry(() => import("./pages/dashboard/vesselReports"));
const ActivityLogPage = lazyRetry(() => import("./pages/dashboard/activityLogPage"));
const NotificationsPage = lazyRetry(() => import("./pages/notifications/notificationsPage"));
const CoNightOrderNewEntry = lazyRetry(() => import("./pages/logs/coNightOrder/newEntry"));
const CoNightOrderHistory = lazyRetry(() => import("./pages/logs/coNightOrder/history"));
const CeNightOrderNewEntry = lazyRetry(() => import("./pages/logs/ceNightOrder/newEntry"));
const CeNightOrderHistory = lazyRetry(() => import("./pages/logs/ceNightOrder/history"));
const BridgeNightOrderNewEntry = lazyRetry(() => import("./pages/logs/bridgeNightOrder/newEntry"));
const BridgeNightOrderHistory = lazyRetry(() => import("./pages/logs/bridgeNightOrder/history"));
const CompassErrorNewEntry = lazyRetry(() => import("./pages/logs/compassError/newEntry"));
const CompassErrorHistory = lazyRetry(() => import("./pages/logs/compassError/history"));
const NearMissDashboard = lazyRetry(() => import("./pages/safety/nearMissDashboard"));
const NearMissNewEntry = lazyRetry(() => import("./pages/safety/nearMiss/newEntry"));
const NearMissHistory = lazyRetry(() => import("./pages/safety/nearMiss/history"));
const NearMissDetail = lazyRetry(() => import("./pages/safety/nearMiss/detail"));
const CreateRole = lazyRetry(() => import("./pages/masterData/role/create"));
const EditRole = lazyRetry(() => import("./pages/masterData/role/edit"));
const ListRole = lazyRetry(() => import("./pages/masterData/role/list"));
const CreateDesignation = lazyRetry(() => import("./pages/masterData/designation/create"));
const EditDesignation = lazyRetry(() => import("./pages/masterData/designation/edit"));
const ListDesignation = lazyRetry(() => import("./pages/masterData/designation/list"));
const CreateUNLocode = lazyRetry(() => import("./pages/masterData/unlocode/create"));
const EditUNLocode = lazyRetry(() => import("./pages/masterData/unlocode/edit"));
const ListUNLocode = lazyRetry(() => import("./pages/masterData/unlocode/list"));
const CreateDepartment = lazyRetry(() => import("./pages/masterData/department/create"));
const EditDepartment = lazyRetry(() => import("./pages/masterData/department/edit"));
const ListDepartment = lazyRetry(() => import("./pages/masterData/department/list"));
const VesselForm = lazyRetry(() => import("./pages/vessel/create"));
const ListVessel = lazyRetry(() => import("./pages/vessel/list"));
const PreviewVessel = lazyRetry(() => import("./pages/vessel/preview"));
const VesselDashboard = lazyRetry(() => import("./pages/vessel/dashboard"));
const CreateUser = lazyRetry(() => import("./pages/user/create"));
const EditUser = lazyRetry(() => import("./pages/user/edit"));
const ListUser = lazyRetry(() => import("./pages/user/list"));
const ListCrew = lazyRetry(() => import("./pages/user/listCrew"));
const CrewProfile = lazyRetry(() => import("./pages/user/crew/profile"));
const CreateVesselOwner = lazyRetry(() => import("./pages/vessel/owner/create"));
const ListVesselOwner = lazyRetry(() => import("./pages/vessel/owner/list"));
const EditVesselOwner = lazyRetry(() => import("./pages/vessel/owner/edit"));
const CreateVesselGroup = lazyRetry(() => import("./pages/vessel/group/create"));
const ListVesselGroup = lazyRetry(() => import("./pages/vessel/group/list"));
const EditVesselGroup = lazyRetry(() => import("./pages/vessel/group/edit"));
const AssignVesselGroup = lazyRetry(() => import("./pages/vessel/group/assignVessel"));
const AssignVesselGroupToCrew = lazyRetry(() => import("./pages/vessel/group/assignCrew"));
const CreateActivityTypeCategory = lazyRetry(() => import("./pages/vessel/activityType/category/create"));
const ListActivityTypeCategory = lazyRetry(() => import("./pages/vessel/activityType/category/list"));
const EditActivityTypeCategory = lazyRetry(() => import("./pages/vessel/activityType/category/edit"));
const CreateActivityType = lazyRetry(() => import("./pages/vessel/activityType/create"));
const ListActivityType = lazyRetry(() => import("./pages/vessel/activityType/list"));
const EditActivityType = lazyRetry(() => import("./pages/vessel/activityType/edit"));
const CreateShipType = lazyRetry(() => import("./pages/vessel/shipType/create"));
const ListShipType = lazyRetry(() => import("./pages/vessel/shipType/list"));
const EditShipType = lazyRetry(() => import("./pages/vessel/shipType/edit"));
const MarpolMasterLanding = lazyRetry(() => import("./pages/marpol/master/landing"));
const MarpolMasterList = lazyRetry(() => import("./pages/marpol/master/list"));
const CreateMarpolMaster = lazyRetry(() => import("./pages/marpol/master/create"));
const EditMarpolMaster = lazyRetry(() => import("./pages/marpol/master/edit"));
const CreateSeaState = lazyRetry(() => import("./pages/masterData/seaState/create"));
const ListSeaState = lazyRetry(() => import("./pages/masterData/seaState/list"));
const EditSeaState = lazyRetry(() => import("./pages/masterData/seaState/edit"));
const CreateShipPurpose = lazyRetry(() => import("./pages/vessel/shipPurpose/create"));
const ListShipPurpose = lazyRetry(() => import("./pages/vessel/shipPurpose/list"));
const EditShipPurpose = lazyRetry(() => import("./pages/vessel/shipPurpose/edit"));
const CreateSupportTicket = lazyRetry(() => import("./pages/support/ticket/create"));
const ListSupportTicket = lazyRetry(() => import("./pages/support/ticket/list"));
const EditSupportTicket = lazyRetry(() => import("./pages/support/ticket/edit"));
const VesselWall = lazyRetry(() => import("./pages/vessel/wall/index"));
const RBAC = lazyRetry(() => import("./pages/rbac/index"));
const AccessControl = lazyRetry(() => import("./pages/accessControl"));
const AccessControlRedirect = lazyRetry(() => import("./pages/accessControl/redirect"));
const SystemConfig = lazyRetry(() => import("./pages/settings/systemConfig"));
const Notifications = lazyRetry(() => import("./pages/settings/notifications"));
const SsoSettings = lazyRetry(() => import("./pages/settings/sso"));
const VesselReportDetail = lazyRetry(() => import("./pages/dashboard/vesselReportDetail"));
const NoonReportForm = lazyRetry(() => import("./pages/dailyReport/engineLog/create"));
const NoonReportList = lazyRetry(() => import("./pages/dailyReport/engineLog/list"));
const NoonReportPreview = lazyRetry(() => import("./pages/dailyReport/engineLog/preview"));
const NoonReport = lazyRetry(() => import("./pages/dailyReport/engineLog/report"));
const DeckLogForm = lazyRetry(() => import("./pages/dailyReport/deckLog/create"));
const DeckLogList = lazyRetry(() => import("./pages/report/deckLog/list"));
const DeckLogPreview = lazyRetry(() => import("./pages/report/deckLog/preview"));
const DeckLogReport = lazyRetry(() => import("./pages/report/deckLog/report"));
const MainEnginePerformanceCreate = lazyRetry(() => import("./pages/monthlyReport/mainEnginePerformance/create"));
const EOMCreate = lazyRetry(() => import("./pages/report/eom/create"));
const AuxiliaryEnginePerformanceCreate = lazyRetry(() => import("./pages/monthlyReport/auxiliaryEnginePerformance/create"));
const AuxiliaryEnginePerformanceList = lazyRetry(() => import("./pages/monthlyReport/auxiliaryEnginePerformance/list"));
const OCONDGCREATE = lazyRetry(() => import("./pages/monthlyReport/OCON/DG/create"));
const OCONMECREATE = lazyRetry(() => import("./pages/monthlyReport/OCON/ME/create"));
const ReeferContainerSparePartsInventoryCreate = lazyRetry(() => import("./pages/monthlyReport/ReeferContainerSparePartsInventory/create"));
const NavigationEquipmentReportsCreate = lazyRetry(() => import("./pages/monthlyReport/NavigationEquipmentReports/create"));
const SDRDamageClaimCreate = lazyRetry(() => import("./pages/monthlyReport/SDRDamageClaim/create"));
const SDRDamageClaimList = lazyRetry(() => import("./pages/monthlyReport/SDRDamageClaim/list"));
const SternTubeRecordingsCreate = lazyRetry(() => import("./pages/monthlyReport/SternTubeRecordings/create"));
const SternTubeRecordingsList = lazyRetry(() => import("./pages/monthlyReport/SternTubeRecordings/list"));
const SternTubeRecordingsPreview = lazyRetry(() => import("./pages/monthlyReport/SternTubeRecordings/preview"));
const CustomerPropertyInventoryCreate = lazyRetry(() => import("./pages/monthlyReport/customerPropertyReport/create"));
const CustomerPropertyInventoryList = lazyRetry(() => import("./pages/monthlyReport/customerPropertyReport/list"));
const CustomerPropertyInventoryPreview = lazyRetry(() => import("./pages/monthlyReport/customerPropertyReport/preview"));
const EssentialMotorsRecordSheetCreate = lazyRetry(() => import("./pages/monthlyReport/EssentialMotorsRecordSheet/create"));
const EquipmentCalibrationRegisterCreate = lazyRetry(() => import("./pages/monthlyReport/EquipmentCalibrationRegister/create"));
const GroupInsuranceForms = lazyRetry(() => import("./pages/monthlyReport/GroupInsuranceForm/create"));
const MECrankshaftBearingConditiondeflections = lazyRetry(() => import("./pages/monthlyReport/MeCrankshaftBearingConditiondeflections/create"));
const AECrankshaftBearingConditiondeflections = lazyRetry(() => import("./pages/monthlyReport/AeCrankshaftBearingConditiondeflections/create"));
const DelayDeviationStatement = lazyRetry(() => import("./pages/monthlyReport/DelayDeviationStatement/create"));
const LubripadInspection = lazyRetry(() => import("./pages/monthlyReport/LubripadInspection/create"));
const StatusOfPendingStevedoreDamages = lazyRetry(() => import("./pages/monthlyReport/StatusOfPendingStevedoreDamages/create"));
const StatusOfPendingStevedoreDamagesDrydockDeferredRepairs = lazyRetry(() => import("./pages/monthlyReport/StatusOfPendingStevedoreDamagesDrydockDeferredRepairs/create"));
const SospReportCreate = lazyRetry(() => import("./pages/dailyReport/sosp/create"));
const EospReportCreate = lazyRetry(() => import("./pages/dailyReport/eosp/create"));
const PortDeparture = lazyRetry(() => import("./pages/dailyReport/port/form"));
const DailyReport = lazyRetry(() => import("./pages/dailyReport/index"));
const MyReports = lazyRetry(() => import("./pages/myReports/index"));
const CreateReportList = lazyRetry(() => import("./pages/report/list"));
const VoyageConfiguration = lazyRetry(() => import("./pages/vessel/voyageConfiguration"));
const VoyageRoutePlanPage = lazyRetry(() => import("./pages/voyage/routePlan"));
const MarpolOrbPart1NewEntry = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/newEntry"));
const MarpolOrbPart1History = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/history"));
const MarpolOrbPart1Dashboard = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/dashboard"));
const MarpolOrbPart1Approvals = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/approvals"));
const MarpolOrbPart1CodeA = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/forms/codeA"));
const MarpolOrbPart1CodeB = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/forms/codeB"));
const MarpolOrbPart1CodeC = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/forms/codeC"));
const MarpolOrbPart1CodeD = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/forms/codeD"));
const MarpolOrbPart1CodeE = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/forms/codeE"));
const MarpolOrbPart1CodeF = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/forms/codeF"));
const MarpolOrbPart1CodeG = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/forms/codeG"));
const MarpolOrbPart1CodeH = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/forms/codeH"));
const MarpolOrbPart1CodeI = lazyRetry(() => import("./pages/marpol/oil-record-book-part-1/forms/codeI"));
const MarpolOrbPart2NewEntry = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/newEntry"));
const MarpolOrbPart2History = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/history"));
const MarpolOrbPart2Dashboard = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/dashboard"));
const MarpolOrbPart2CodeA = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeA"));
const MarpolOrbPart2CodeB = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeB"));
const MarpolOrbPart2CodeC = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeC"));
const MarpolOrbPart2CodeD = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeD"));
const MarpolOrbPart2CodeE = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeE"));
const MarpolOrbPart2CodeF = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeF"));
const MarpolOrbPart2CodeG = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeG"));
const MarpolOrbPart2CodeH = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeH"));
const MarpolOrbPart2CodeI = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeI"));
const MarpolOrbPart2CodeJ = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeJ"));
const MarpolOrbPart2CodeK = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeK"));
const MarpolOrbPart2CodeL = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeL"));
const MarpolOrbPart2CodeO = lazyRetry(() => import("./pages/marpol/oil-record-book-part-2/forms/codeO"));
const MarpolGarbageNewEntry = lazyRetry(() => import("./pages/marpol/garbage-record-book/newEntry"));
const MarpolMissedEntryPage = lazyRetry(() => import("./pages/marpol/missedEntry"));
const MarpolGarbageHistory = lazyRetry(() => import("./pages/marpol/garbage-record-book/history"));
const MarpolGarbageDashboard = lazyRetry(() => import("./pages/marpol/garbage-record-book/dashboard"));
const MarpolGarbageType1 = lazyRetry(() => import("./pages/marpol/garbage-record-book/forms/type1-prf"));
const MarpolGarbageType2 = lazyRetry(() => import("./pages/marpol/garbage-record-book/forms/type2-incineration"));
const MarpolGarbageType3 = lazyRetry(() => import("./pages/marpol/garbage-record-book/forms/type3-discharge"));
const MarpolGarbageType4 = lazyRetry(() => import("./pages/marpol/garbage-record-book/forms/type4-accidental"));
const MarpolBallastNewEntry = lazyRetry(() => import("./pages/marpol/ballast-water-record/newEntry"));
const MarpolBallastHistory = lazyRetry(() => import("./pages/marpol/ballast-water-record/history"));
const MarpolBallastDashboard = lazyRetry(() => import("./pages/marpol/ballast-water-record/dashboard"));
const MarpolBallastCodeA = lazyRetry(() => import("./pages/marpol/ballast-water-record/forms/codeA"));
const MarpolBallastCodeB = lazyRetry(() => import("./pages/marpol/ballast-water-record/forms/codeB"));
const MarpolBallastCodeC = lazyRetry(() => import("./pages/marpol/ballast-water-record/forms/codeC"));
const MarpolBallastCodeD = lazyRetry(() => import("./pages/marpol/ballast-water-record/forms/codeD"));
const MarpolBallastCodeE = lazyRetry(() => import("./pages/marpol/ballast-water-record/forms/codeE"));
const MarpolBallastCodeF = lazyRetry(() => import("./pages/marpol/ballast-water-record/forms/codeF"));
const MarpolBallastCodeG = lazyRetry(() => import("./pages/marpol/ballast-water-record/forms/codeG"));
const MarpolBallastCodeH = lazyRetry(() => import("./pages/marpol/ballast-water-record/forms/codeH"));
const MarpolBiofoulingNewEntry = lazyRetry(() => import("./pages/marpol/biofouling-record-book/newEntry"));
const MarpolBiofoulingHistory = lazyRetry(() => import("./pages/marpol/biofouling-record-book/history"));
const MarpolBiofoulingDashboard = lazyRetry(() => import("./pages/marpol/biofouling-record-book/dashboard"));
const MarpolBiofoulingSection1 = lazyRetry(() => import("./pages/marpol/biofouling-record-book/forms/section1-afs"));
const MarpolBiofoulingSection2 = lazyRetry(() => import("./pages/marpol/biofouling-record-book/forms/section2-inspection"));
const MarpolBiofoulingSection3 = lazyRetry(() => import("./pages/marpol/biofouling-record-book/forms/section3-cleaning"));
const MarpolAnnexIVNewEntry = lazyRetry(() => import("./pages/marpol/annex-iv-record/newEntry"));
const MarpolAnnexIVHistory = lazyRetry(() => import("./pages/marpol/annex-iv-record/history"));
const MarpolAnnexIVDashboard = lazyRetry(() => import("./pages/marpol/annex-iv-record/dashboard"));
const MarpolAnnexIVType1 = lazyRetry(() => import("./pages/marpol/annex-iv-record/forms/type1-stp-log"));
const MarpolAnnexIVType2 = lazyRetry(() => import("./pages/marpol/annex-iv-record/forms/type2-discharge"));
const MarpolAnnexIVType3 = lazyRetry(() => import("./pages/marpol/annex-iv-record/forms/type3-prf"));
const MarpolAnnexIVType4 = lazyRetry(() => import("./pages/marpol/annex-iv-record/forms/type4-holding"));
const MarpolAnnexVINewEntry = lazyRetry(() => import("./pages/marpol/annex-vi-record/newEntry"));
const MarpolAnnexVIHistory = lazyRetry(() => import("./pages/marpol/annex-vi-record/history"));
const MarpolAnnexVIDashboard = lazyRetry(() => import("./pages/marpol/annex-vi-record/dashboard"));
const MarpolAnnexVICodeA = lazyRetry(() => import("./pages/marpol/annex-vi-record/forms/codeA-bunkering"));
const MarpolAnnexVICodeB = lazyRetry(() => import("./pages/marpol/annex-vi-record/forms/codeB-sample-tracking"));
const MarpolAnnexVICodeC = lazyRetry(() => import("./pages/marpol/annex-vi-record/forms/codeC-sample-transfer"));
const MarpolAnnexVICodeD = lazyRetry(() => import("./pages/marpol/annex-vi-record/forms/codeD-changeover"));
const MarpolAnnexVICodeE = lazyRetry(() => import("./pages/marpol/annex-vi-record/forms/codeE-egcs"));
const MarpolAnnexVICodeF = lazyRetry(() => import("./pages/marpol/annex-vi-record/forms/codeF-neca"));
const MarpolAnnexVICodeG = lazyRetry(() => import("./pages/marpol/annex-vi-record/forms/codeG-egr"));
const MarpolAnnexVICodeH = lazyRetry(() => import("./pages/marpol/annex-vi-record/forms/codeH-failure"));
const MarpolAnnexVICodeI = lazyRetry(() => import("./pages/marpol/annex-vi-record/forms/codeI-ods"));
const MarpolAnnexVICodeJ = lazyRetry(() => import("./pages/marpol/annex-vi-record/forms/codeJ-additional"));
const EUMRVData = lazyRetry(() => import("./pages/envPerformance/euMrvData"));
const IMODcs = lazyRetry(() => import("./pages/envPerformance/imoDcs"));
const KPIDashboard = lazyRetry(() => import("./pages/kpi/dashboard"));
const KPITechnicalMainEngine = lazyRetry(() => import("./pages/kpi/technical/mainEngine"));
const KPITechnicalAuxEngine = lazyRetry(() => import("./pages/kpi/technical/auxEngine"));
const KPITechnicalPurifier = lazyRetry(() => import("./pages/kpi/technical/purifier"));
const KPITechnicalLoAnalysisReport = lazyRetry(() => import("./pages/kpi/technical/loAnlysisReport"));
const KPITechnicalAnalysisofBreakdowns = lazyRetry(() => import("./pages/kpi/technical/analysisofBreakdowns"));
const KPITechnicalRequisitionStatus = lazyRetry(() => import("./pages/kpi/technical/requisitionStatus"));
const KPICommercialPscInspection = lazyRetry(() => import("./pages/kpi/commercial/pscInspection"));
const KPICommercialRightshipRating = lazyRetry(() => import("./pages/kpi/commercial/rightshipRating"));
const KPICommercialCustomerSatisfaction = lazyRetry(() => import("./pages/kpi/commercial/customerSatisfaction"));
const KPICommercialBudget = lazyRetry(() => import("./pages/kpi/commercial/budget"));
const KPICommercialDamagesAndDelays = lazyRetry(() => import("./pages/kpi/commercial/damagesAndDelays"));
const KPIVesselConditionLoadLineModule = lazyRetry(() => import("./pages/kpi/vesselCondition/loadLineModule"));
const KPIVesselConditionVir = lazyRetry(() => import("./pages/kpi/vesselCondition/vir"));
const KPIVesselConditionHatchCover = lazyRetry(() => import("./pages/kpi/vesselCondition/hatchCover"));
const KPIVesselConditionCargoGear = lazyRetry(() => import("./pages/kpi/vesselCondition/cargoGear"));
const KPIVesselConditionDeckMaintenance = lazyRetry(() => import("./pages/kpi/vesselCondition/deckMaintenance"));
const KPIVesselConditionParisUpdate = lazyRetry(() => import("./pages/kpi/vesselCondition/parisUpdate"));
const KPISafetyEnvMarpol = lazyRetry(() => import("./pages/kpi/safety/marpol"));
const KPISafetyEnvBilgeGeneration = lazyRetry(() => import("./pages/kpi/safety/bilgeGeneration"));
const KPISafetyEnvLtiNearMisses = lazyRetry(() => import("./pages/kpi/safety/ltiNearMisses"));
const KPIDataBase = lazyRetry(() => import("./pages/kpi/technical/dataBase"));
const KPISetup = lazyRetry(() => import("./pages/kpi/setup"));

const Router = () => {
  return (
    <Suspense fallback={<Loader />}>
    <Routes>
      {/* Protected routes */}
      <Route element={<PrivateRoute />}>

        <Route path={constant.Authedcomponent.dashboard.url} element={<Dashboard />} />
        <Route path={constant.Authedcomponent.adminVesselReports.url} element={<AdminVesselReports />} />
        <Route path={constant.Authedcomponent.adminActivityLog.url} element={<ActivityLogPage />} />
        <Route path={constant.Authedcomponent.notificationsCenter.url} element={<NotificationsPage />} />
        <Route path={constant.Authedcomponent.coNightOrderNewEntry.url} element={<CoNightOrderNewEntry />} />
        <Route path={constant.Authedcomponent.coNightOrderHistory.url} element={<CoNightOrderHistory />} />
        <Route path={constant.Authedcomponent.ceNightOrderNewEntry.url} element={<CeNightOrderNewEntry />} />
        <Route path={constant.Authedcomponent.ceNightOrderHistory.url} element={<CeNightOrderHistory />} />
        <Route path={constant.Authedcomponent.bridgeNightOrderNewEntry.url} element={<BridgeNightOrderNewEntry />} />
        <Route path={constant.Authedcomponent.bridgeNightOrderHistory.url} element={<BridgeNightOrderHistory />} />
        <Route path={constant.Authedcomponent.compassErrorLogNewEntry.url} element={<CompassErrorNewEntry />} />
        <Route path={constant.Authedcomponent.compassErrorLogHistory.url} element={<CompassErrorHistory />} />
        <Route path={constant.Authedcomponent.nearMissDashboard.url} element={<NearMissDashboard />} />
        <Route path={constant.Authedcomponent.nearMissNewEntry.url} element={<NearMissNewEntry />} />
        <Route path={constant.Authedcomponent.nearMissHistory.url} element={<NearMissHistory />} />
        <Route path={`${constant.Authedcomponent.nearMissDetail.url}/:uid`} element={<NearMissDetail />} />
        <Route path={constant.Authedcomponent.adminVesselReportDetail.url} element={<VesselReportDetail />} />

        <Route path={constant.Authedcomponent.addRole.url} element={<AccessControlRedirect section="roles" />} />
        <Route path={constant.Authedcomponent.editRole.url} element={<AccessControlRedirect section="roles" />} />
        <Route path={constant.Authedcomponent.listRole.url} element={<AccessControlRedirect section="roles" />} />

        <Route path={constant.Authedcomponent.addDesignation.url} element={<AccessControlRedirect section="designations" />} />
        <Route path={constant.Authedcomponent.editDesignation.url} element={<AccessControlRedirect section="designations" />} />
        <Route path={constant.Authedcomponent.listDesignation.url} element={<AccessControlRedirect section="designations" />} />



        <Route path={constant.Authedcomponent.addUNLocode.url} element={<CreateUNLocode />} />
        <Route path={constant.Authedcomponent.editUNLocode.url} element={<EditUNLocode />} />
        <Route path={constant.Authedcomponent.listUNLocode.url} element={<ListUNLocode />} />

        <Route path={constant.Authedcomponent.addDepartment.url} element={<AccessControlRedirect section="departments" />} />
        <Route path={constant.Authedcomponent.editDepartment.url} element={<AccessControlRedirect section="departments" />} />
        <Route path={constant.Authedcomponent.listDepartment.url} element={<AccessControlRedirect section="departments" />} />




        <Route path={constant.Authedcomponent.addActivityTypeCategory.url} element={<CreateActivityTypeCategory />} />
        <Route path={constant.Authedcomponent.editActivityTypeCategory.url} element={<EditActivityTypeCategory />} />
        <Route path={constant.Authedcomponent.listActivityTypeCategory.url} element={<ListActivityTypeCategory />} />



        <Route path={constant.Authedcomponent.addActivityType.url} element={<CreateActivityType />} />
        <Route path={constant.Authedcomponent.editActivityType.url} element={<EditActivityType />} />
        <Route path={constant.Authedcomponent.listActivityType.url} element={<ListActivityType />} />

        <Route path={constant.Authedcomponent.addUser.url} element={<CreateUser />} />
        <Route path={constant.Authedcomponent.listUser.url} element={<ListUser />} />
        <Route path={constant.Authedcomponent.editUser.url} element={<EditUser />} />
        <Route path={constant.Authedcomponent.crewProfile.url} element={<CrewProfile />} />
        <Route path={constant.Authedcomponent.listCrew.url} element={<ListCrew />} />


        <Route path={constant.Authedcomponent.addVesselOwner.url} element={<CreateVesselOwner />} />
        <Route path={constant.Authedcomponent.listVesselOwner.url} element={<ListVesselOwner />} />
        <Route path={constant.Authedcomponent.editVesselOwner.url} element={<EditVesselOwner />} />





        <Route path={constant.Authedcomponent.addShipType.url} element={<CreateShipType />} />
        <Route path={constant.Authedcomponent.listShipType.url} element={<ListShipType />} />
        <Route path={constant.Authedcomponent.editShipType.url} element={<EditShipType />} />
        <Route path="/marpol-master" element={<MarpolMasterLanding />} />
        <Route path={constant.Authedcomponent.marpolMasterList.url} element={<MarpolMasterList />} />
        <Route path={constant.Authedcomponent.marpolMasterCategory.url} element={<MarpolMasterList />} />
        <Route path={constant.Authedcomponent.marpolMasterAdd.url} element={<CreateMarpolMaster />} />
        <Route path={constant.Authedcomponent.marpolMasterEdit.url} element={<EditMarpolMaster />} />


        <Route path={constant.Authedcomponent.addSeaState.url} element={<CreateSeaState />} />
        <Route path={constant.Authedcomponent.listSeaState.url} element={<ListSeaState />} />
        <Route path={constant.Authedcomponent.editSeaState.url} element={<EditSeaState />} />



        <Route path={constant.Authedcomponent.addShipPurpose.url} element={<CreateShipPurpose />} />
        <Route path={constant.Authedcomponent.listShipPurpose.url} element={<ListShipPurpose />} />
        <Route path={constant.Authedcomponent.editShipPurpose.url} element={<EditShipPurpose />} />



        <Route path={constant.Authedcomponent.addVesselGroup.url} element={<CreateVesselGroup />} />
        <Route path={constant.Authedcomponent.listVesselGroup.url} element={<ListVesselGroup />} />
        <Route path={constant.Authedcomponent.editVesselGroup.url} element={<EditVesselGroup />} />
        <Route path={constant.Authedcomponent.assignVesselGroup.url} element={<AssignVesselGroup />} />
        <Route path={constant.Authedcomponent.assignVesselGroupToCrew.url} element={<AssignVesselGroupToCrew />} />



        <Route path={constant.Authedcomponent.addVessel.url} element={<VesselForm />} />
        <Route path={constant.Authedcomponent.editVessel.url} element={<VesselForm />} />
        <Route path={constant.Authedcomponent.listVessel.url} element={<ListVessel />} />
        <Route path={constant.Authedcomponent.previewVessel.url} element={<PreviewVessel />} />
        <Route element={<CrewOnlyRoute redirectTo={constant.Authedcomponent.adminVesselReports.url} />}>
          <Route path={constant.Authedcomponent.vesselDashboard.url} element={<VesselDashboard />} />
        </Route>




        <Route path={constant.Authedcomponent.ticketList.url} element={<ListSupportTicket />} />
        <Route path={constant.Authedcomponent.createTicket.url} element={<CreateSupportTicket />} />
        <Route path={constant.Authedcomponent.editTicket.url} element={<EditSupportTicket />} />

        <Route path={constant.Authedcomponent.vesselWall.url} element={<VesselWall />} />




        <Route path={constant.Authedcomponent.listRBAC.url} element={<RBAC />} />
        <Route path={constant.Authedcomponent.accessControl.url} element={<AccessControl />} />
        <Route path={constant.Authedcomponent.systemConfig.url} element={<SystemConfig />} />
        <Route path={constant.Authedcomponent.notifications.url} element={<Notifications />} />
        <Route path={constant.Authedcomponent.ssoSettings.url} element={<SsoSettings />} />
        {/* Read-only / list / preview routes — always available */}
        <Route path={constant.Authedcomponent.noonReportList.url} element={<NoonReportList />} />
        <Route path={constant.Authedcomponent.noonReportPreview.url} element={<NoonReportPreview />} />
        <Route path={constant.Authedcomponent.noonReportReport.url} element={<NoonReport />} />

        <Route path={constant.Authedcomponent.deckLogList.url} element={<DeckLogList />} />
        <Route path={constant.Authedcomponent.deckLogPreview.url} element={<DeckLogPreview />} />
        <Route path={constant.Authedcomponent.deckLogReport.url} element={<DeckLogReport />} />

        <Route path={constant.Authedcomponent.auxiliaryEnginePerformaceDataReportList.url} element={<AuxiliaryEnginePerformanceList />} />

        <Route path={constant.Authedcomponent.createReportList.url} element={<CreateReportList />} />

        <Route path={constant.Authedcomponent.vesselReports.url} element={<DailyReport />} />
        <Route path={constant.Authedcomponent.myDailyReports.url} element={<MyReports />} />

        {/* ====================================================
             CREW-ONLY routes — Super Admin is bounced out.
             Data is entered by vessel crew; admins only view.
            ==================================================== */}
        <Route element={<CrewOnlyRoute />}>
          <Route path={constant.Authedcomponent.engineLogCreate.url} element={<NoonReportForm />} />
          <Route path={constant.Authedcomponent.noonReportCreate.url} element={<DeckLogForm />} />
          <Route path={constant.Authedcomponent.deckLog.url} element={<DeckLogForm />} />

          <Route path={constant.Authedcomponent.mainEnginePerformaceReportCreate.url} element={<MainEnginePerformanceCreate />} />
          <Route path={constant.Authedcomponent.eomReportCreate.url} element={<EOMCreate />} />
          <Route path={constant.Authedcomponent.auxiliaryEnginePerformaceDataReportCreate.url} element={<AuxiliaryEnginePerformanceCreate />} />

          <Route path={constant.Authedcomponent.startVoyage.url} element={<PortDeparture />} />
          <Route path={constant.Authedcomponent.portArrivalReportCreate.url} element={<PortDeparture />} />
          <Route path={constant.Authedcomponent.sospReportCreate.url} element={<SospReportCreate />} />
          <Route path={constant.Authedcomponent.eospReportCreate.url} element={<EospReportCreate />} />
        </Route>

        <Route path={constant.Authedcomponent.voyageRoutePlan.url} element={<VoyageRoutePlanPage />} />
        <Route path={constant.Authedcomponent.voyageConfiguration.url} element={<VoyageConfiguration />} />



        {/* ================= MARPOL ROUTES ================= */}
        {/* History pages: open to all viewers (incl. Super Admin) */}
        <Route path={constant.Authedcomponent.marpolOrbPart1History.url} element={<MarpolOrbPart1History />} />
        <Route path={constant.Authedcomponent.marpolOrbPart1Dashboard.url} element={<MarpolOrbPart1Dashboard />} />
        <Route path={constant.Authedcomponent.marpolOrbPart1Approvals.url} element={<MarpolOrbPart1Approvals />} />
        <Route path={constant.Authedcomponent.marpolOrbPart2History.url} element={<MarpolOrbPart2History />} />
        <Route path={constant.Authedcomponent.marpolOrbPart2Dashboard.url} element={<MarpolOrbPart2Dashboard />} />
        <Route path={constant.Authedcomponent.marpolGarbageHistory.url} element={<MarpolGarbageHistory />} />
        <Route path={constant.Authedcomponent.marpolGarbageDashboard.url} element={<MarpolGarbageDashboard />} />
        <Route path={constant.Authedcomponent.marpolBallastHistory.url} element={<MarpolBallastHistory />} />
        <Route path={constant.Authedcomponent.marpolBallastDashboard.url} element={<MarpolBallastDashboard />} />
        <Route path={constant.Authedcomponent.marpolBiofoulingHistory.url} element={<MarpolBiofoulingHistory />} />
        <Route path={constant.Authedcomponent.marpolBiofoulingDashboard.url} element={<MarpolBiofoulingDashboard />} />
        <Route path={constant.Authedcomponent.marpolAnnexIVHistory.url} element={<MarpolAnnexIVHistory />} />
        <Route path={constant.Authedcomponent.marpolAnnexIVDashboard.url} element={<MarpolAnnexIVDashboard />} />
        <Route path={constant.Authedcomponent.marpolAnnexVIHistory.url} element={<MarpolAnnexVIHistory />} />
        <Route path={constant.Authedcomponent.marpolAnnexVIDashboard.url} element={<MarpolAnnexVIDashboard />} />

        {/* ====================================================
             MARPOL CREW-ONLY routes — Super Admin is blocked.
             Vessel crew submits entries; admins only review.
            ==================================================== */}
        <Route element={<CrewOnlyRoute />}>
          {/* -------- OIL RECORD BOOK PART I -------- */}
          <Route path={constant.Authedcomponent.marpolOrbPart1NewEntry.url} element={<MarpolOrbPart1NewEntry />} />
          <Route path={constant.Authedcomponent.marpolOrbPart1CodeA.url} element={<MarpolOrbPart1CodeA />} />
          <Route path={constant.Authedcomponent.marpolOrbPart1CodeB.url} element={<MarpolOrbPart1CodeB />} />
          <Route path={constant.Authedcomponent.marpolOrbPart1CodeC.url} element={<MarpolOrbPart1CodeC />} />
          <Route path={constant.Authedcomponent.marpolOrbPart1CodeD.url} element={<MarpolOrbPart1CodeD />} />
          <Route path={constant.Authedcomponent.marpolOrbPart1CodeE.url} element={<MarpolOrbPart1CodeE />} />
          <Route path={constant.Authedcomponent.marpolOrbPart1CodeF.url} element={<MarpolOrbPart1CodeF />} />
          <Route path={constant.Authedcomponent.marpolOrbPart1CodeG.url} element={<MarpolOrbPart1CodeG />} />
          <Route path={constant.Authedcomponent.marpolOrbPart1CodeH.url} element={<MarpolOrbPart1CodeH />} />
          <Route path={constant.Authedcomponent.marpolOrbPart1CodeI.url} element={<MarpolOrbPart1CodeI />} />

          {/* -------- OIL RECORD BOOK PART II -------- */}
          <Route path={constant.Authedcomponent.marpolOrbPart2NewEntry.url} element={<MarpolOrbPart2NewEntry />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeA.url} element={<MarpolOrbPart2CodeA />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeB.url} element={<MarpolOrbPart2CodeB />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeC.url} element={<MarpolOrbPart2CodeC />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeD.url} element={<MarpolOrbPart2CodeD />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeE.url} element={<MarpolOrbPart2CodeE />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeF.url} element={<MarpolOrbPart2CodeF />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeG.url} element={<MarpolOrbPart2CodeG />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeH.url} element={<MarpolOrbPart2CodeH />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeI.url} element={<MarpolOrbPart2CodeI />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeJ.url} element={<MarpolOrbPart2CodeJ />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeK.url} element={<MarpolOrbPart2CodeK />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeL.url} element={<MarpolOrbPart2CodeL />} />
          <Route path={constant.Authedcomponent.marpolOrbPart2CodeO.url} element={<MarpolOrbPart2CodeO />} />

          {/* -------- GARBAGE RECORD BOOK -------- */}
          <Route path={constant.Authedcomponent.marpolGarbageNewEntry.url} element={<MarpolGarbageNewEntry />} />
          <Route path="/marpol/missed-entry/:bookModule" element={<MarpolMissedEntryPage />} />
          <Route path={constant.Authedcomponent.marpolGarbageType1.url} element={<MarpolGarbageType1 />} />
          <Route path={constant.Authedcomponent.marpolGarbageType2.url} element={<MarpolGarbageType2 />} />
          <Route path={constant.Authedcomponent.marpolGarbageType3.url} element={<MarpolGarbageType3 />} />
          <Route path={constant.Authedcomponent.marpolGarbageType4.url} element={<MarpolGarbageType4 />} />

          {/* -------- BALLAST WATER RECORD -------- */}
          <Route path={constant.Authedcomponent.marpolBallastNewEntry.url} element={<MarpolBallastNewEntry />} />
          <Route path={constant.Authedcomponent.marpolBallastCodeA.url} element={<MarpolBallastCodeA />} />
          <Route path={constant.Authedcomponent.marpolBallastCodeB.url} element={<MarpolBallastCodeB />} />
          <Route path={constant.Authedcomponent.marpolBallastCodeC.url} element={<MarpolBallastCodeC />} />
          <Route path={constant.Authedcomponent.marpolBallastCodeD.url} element={<MarpolBallastCodeD />} />
          <Route path={constant.Authedcomponent.marpolBallastCodeE.url} element={<MarpolBallastCodeE />} />
          <Route path={constant.Authedcomponent.marpolBallastCodeF.url} element={<MarpolBallastCodeF />} />
          <Route path={constant.Authedcomponent.marpolBallastCodeG.url} element={<MarpolBallastCodeG />} />
          <Route path={constant.Authedcomponent.marpolBallastCodeH.url} element={<MarpolBallastCodeH />} />

          {/* -------- BIOFOULING RECORD BOOK -------- */}
          <Route path={constant.Authedcomponent.marpolBiofoulingNewEntry.url} element={<MarpolBiofoulingNewEntry />} />
          <Route path={constant.Authedcomponent.marpolBiofoulingSection1.url} element={<MarpolBiofoulingSection1 />} />
          <Route path={constant.Authedcomponent.marpolBiofoulingSection2.url} element={<MarpolBiofoulingSection2 />} />
          <Route path={constant.Authedcomponent.marpolBiofoulingSection3.url} element={<MarpolBiofoulingSection3 />} />

          {/* -------- ANNEX IV RECORD -------- */}
          <Route path={constant.Authedcomponent.marpolAnnexIVNewEntry.url} element={<MarpolAnnexIVNewEntry />} />
          <Route path={constant.Authedcomponent.marpolAnnexIVType1.url} element={<MarpolAnnexIVType1 />} />
          <Route path={constant.Authedcomponent.marpolAnnexIVType2.url} element={<MarpolAnnexIVType2 />} />
          <Route path={constant.Authedcomponent.marpolAnnexIVType3.url} element={<MarpolAnnexIVType3 />} />
          <Route path={constant.Authedcomponent.marpolAnnexIVType4.url} element={<MarpolAnnexIVType4 />} />

          {/* -------- ANNEX VI RECORD -------- */}
          <Route path={constant.Authedcomponent.marpolAnnexVINewEntry.url} element={<MarpolAnnexVINewEntry />} />
          <Route path={constant.Authedcomponent.marpolAnnexVICodeA.url} element={<MarpolAnnexVICodeA />} />
          <Route path={constant.Authedcomponent.marpolAnnexVICodeB.url} element={<MarpolAnnexVICodeB />} />
          <Route path={constant.Authedcomponent.marpolAnnexVICodeC.url} element={<MarpolAnnexVICodeC />} />
          <Route path={constant.Authedcomponent.marpolAnnexVICodeD.url} element={<MarpolAnnexVICodeD />} />
          <Route path={constant.Authedcomponent.marpolAnnexVICodeE.url} element={<MarpolAnnexVICodeE />} />
          <Route path={constant.Authedcomponent.marpolAnnexVICodeF.url} element={<MarpolAnnexVICodeF />} />
          <Route path={constant.Authedcomponent.marpolAnnexVICodeG.url} element={<MarpolAnnexVICodeG />} />
          <Route path={constant.Authedcomponent.marpolAnnexVICodeH.url} element={<MarpolAnnexVICodeH />} />
          <Route path={constant.Authedcomponent.marpolAnnexVICodeI.url} element={<MarpolAnnexVICodeI />} />
          <Route path={constant.Authedcomponent.marpolAnnexVICodeJ.url} element={<MarpolAnnexVICodeJ />} />
        </Route>
        <Route
          path={constant.Authedcomponent.euMrvData.url}
          element={<EUMRVData />}
        />

        <Route
          path={constant.Authedcomponent.imoDcs.url}
          element={<IMODcs />}
        />



        <Route
          path={constant.Authedcomponent.kpiDashboard.url}
          element={<KPIDashboard />}
        />

        <Route
          path={constant.Authedcomponent.kpiTechnicalAuxEngine.url}
          element={<KPITechnicalAuxEngine />}
        />

        <Route
          path={constant.Authedcomponent.kpiTechnicalMainEngine.url}
          element={<KPITechnicalMainEngine />}
        />

        <Route
          path={constant.Authedcomponent.KPITechnicalPurifier.url}
          element={<KPITechnicalPurifier />}
        />
        <Route
          path={constant.Authedcomponent.KPITechnicalLoAnalysisReport.url}
          element={<KPITechnicalLoAnalysisReport />}
        />
        <Route
          path={constant.Authedcomponent.KPITechnicalAnalysisofcBreakdowns.url}
          element={<KPITechnicalAnalysisofBreakdowns />}
        />
        <Route
          path={constant.Authedcomponent.KPITechnicalRequisitionStatus.url}
          element={<KPITechnicalRequisitionStatus />}
        />
        <Route
          path={constant.Authedcomponent.KPICommercialPscInspection.url}
          element={<KPICommercialPscInspection />}
        />
        <Route
          path={constant.Authedcomponent.KPICommercialRightshipRating.url}
          element={<KPICommercialRightshipRating />}
        />
        <Route
          path={constant.Authedcomponent.KPICommercialCustomerSatisfaction.url}
          element={<KPICommercialCustomerSatisfaction />}
        />
        <Route
          path={constant.Authedcomponent.KPICommercialBudget.url}
          element={<KPICommercialBudget />}
        />
        <Route
          path={constant.Authedcomponent.KPICommercialDamagesAndDelays.url}
          element={<KPICommercialDamagesAndDelays />}
        />
        <Route
          path={constant.Authedcomponent.KPIVesselConditionLoadLineModule.url}
          element={<KPIVesselConditionLoadLineModule />}
        />
        <Route
          path={constant.Authedcomponent.KPIVesselConditionVir.url}
          element={<KPIVesselConditionVir />}
        />
        <Route
          path={constant.Authedcomponent.KPIVesselConditionHatchCover.url}
          element={<KPIVesselConditionHatchCover />}
        />
        <Route
          path={constant.Authedcomponent.KPIVesselConditionCargoGear.url}
          element={<KPIVesselConditionCargoGear />}
        />
        <Route
          path={constant.Authedcomponent.KPIVesselConditionDeckMaintenance.url}
          element={<KPIVesselConditionDeckMaintenance />}
        />
        <Route
          path={constant.Authedcomponent.KPIVesselConditionParisUpdate.url}
          element={<KPIVesselConditionParisUpdate />}
        />
        <Route
          path={constant.Authedcomponent.KPISafetyEnvMarpol.url}
          element={<KPISafetyEnvMarpol />}
        />
        <Route
          path={constant.Authedcomponent.KPISafetyEnvBilgeGeneration.url}
          element={<KPISafetyEnvBilgeGeneration />}
        />
        <Route
          path={constant.Authedcomponent.KPISafetyEnvLtiNearMisses.url}
          element={<KPISafetyEnvLtiNearMisses />}
        />
        <Route
          path={constant.Authedcomponent.KPIDataBase.url}
          element={<KPIDataBase />}
        />
        <Route
          path={constant.Authedcomponent.KPISetup.url}
          element={<KPISetup />}
        />




      </Route>

      <Route element={<ByPassPrivateRoute />}>
        {/* <Route path={constant.Authedcomponent.crewDashboard.url} element={<CrewDashboard />} /> */}

        {/* <Route path={constant.Authedcomponent.addVessel.url} element={<CreateVessel />} /> */}
        {/* <Route path={constant.Authedcomponent.listVessel.url} element={<ListVessel />} /> */}
        {/* <Route path={constant.Authedcomponent.previewVessel.url} element={<PreviewVessel />} /> */}

        {/* <Route path={constant.Authedcomponent.crewProfile.url} element={<CrewProfile />} /> */}
        {/* <Route path={constant.Authedcomponent.dashboard.url} element={<Dashboard />} /> */}

      </Route>

      {/* Non-auth routes */}
      <Route element={<NonAuthedRoute />}>
        <Route path={constant.nonAuthedcomponent.login.url} element={<Login />} />
        <Route path={constant.nonAuthedcomponent.forgetPin.url} element={<ForgetPin />} />
        <Route path={constant.nonAuthedcomponent.resetPin.url} element={<ResetPin />} />
        <Route path={constant.nonAuthedcomponent.setPin.url} element={<SetPin />} />
        <Route path={constant.nonAuthedcomponent.ssoCallback.url} element={<SsoCallback />} />
      </Route>
      <Route element={<CommonRoute />}>
        <Route path={constant.commoncomponent.logout.url} element={<Logout />} />
      </Route>
    </Routes>
    </Suspense>
  );
};

export default Router;
